import { Injectable } from '@angular/core';
import { CanActivate } from '@nestjs/common';
import { Router } from '@angular/router';
import {Store} from '@ngxs/store';
import {UserState} from '../../shared/user-state/user.state';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {

  constructor(public router: Router, private store: Store) {
  }

  canActivate(): boolean {
    const userState = this.store.selectSnapshot(UserState.user);
    if (!userState || !userState.isLoggedIn) {
      this.router.navigate(['login']);
      return false;
    }
    return true;
  }
}
